import { BrowserRouter ,Routes, Route } from "react-router-dom";
import PrivateRoute from "./pages/ava-admin/PrivateRoute";
import Home from "./pages/home";
import PublicDemos from "./pages/demo/index"
import DemoById from "./pages/demo/[id]";
import ResearchPaper from "./pages/researchpaper/[id]";
import AvaAdmin from "./pages/ava-admin";
import Topics from "./pages/ava-admin/topics";
import AddTopic from "./pages/ava-admin/topics/add";
import UpdateTopic from "./pages/ava-admin/topics/update/[id]";
import ResearchPapers from "./pages/ava-admin/researchpapers/";
import AddResearchPaper from "./pages/ava-admin/researchpapers/add";
import UpdateResearchPaper from "./pages/ava-admin/researchpapers/update/[id]";
import Demos from "./pages/ava-admin/demo";
import AddDemo from "./pages/ava-admin/demo/add";
import UpdateDemo from "./pages/ava-admin/demo/update/[id]";
import Callback from "./pages/ava-admin/callback";
import PageNotFound from "./pages/404";
import PageUnauthorize from "./pages/401";
import Logout from "./pages/ava-admin/logout";
import Login from "./pages/login";
import Blog from "./pages/blog";
import AddBlogs from "./pages/ava-admin/blogs/add";
import UpdateBlogs from "./pages/ava-admin/blogs/update/[id]";
import Blogs from "./pages/ava-admin/blogs";
import BlogByID from "./pages/blog/[id]";
import PublicResearchPapers from "./pages/researchpapers";
import Overviews from "./pages/ava-admin/overview";
import AddOverview from "./pages/ava-admin/overview/add";
import UpdateOverview from "./pages/ava-admin/overview/update/[id]";

const App = () => {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />}/>
        <Route path="/blogs" element={<Blog />}/>
        <Route path="/demo" element={<PublicDemos />}/>
        <Route path="/demo/:id" element={<DemoById />}/>
        <Route path="/researchpapers" element={<PublicResearchPapers />}/>
        <Route path="/researchpaper/:id" element={<ResearchPaper />}/>
        <Route path="/blog/:id" element={<BlogByID />}/>
        <Route path="/ava-admin/callback" element={<Callback />}/>
        <Route path="/ava-admin/logout" element={<Logout />}/>
        <Route path="/ava-admin/login" element={<Login />}/>

        {/* Private Routes for Admin */}

        <Route element={<PrivateRoute />}>
          <Route path="/ava-admin">
            <Route index element={<AvaAdmin />} />
            <Route path="topics" element={<Topics />}/>
            <Route path="topics/add" element={<AddTopic />}/>
            <Route path="topics/update/:id" element={<UpdateTopic />}/>
            <Route path="researchpapers" element={<ResearchPapers />}/>
            <Route path="researchpapers/add" element={<AddResearchPaper />}/>
            <Route path="researchpapers/update/:id" element={<UpdateResearchPaper />}/>
            <Route path="demos" element={<Demos />}/>
            <Route path="demos/add" element={<AddDemo />} />
            <Route path="demos/update/:id" element={<UpdateDemo />} />
            <Route path="blogs" element={<Blogs />}/>
            <Route path="blogs/add" element={<AddBlogs />} />
            <Route path="blogs/update/:id" element={<UpdateBlogs />} />
            <Route path="overview" element={<Overviews />} />
            <Route path="overview/add" element={<AddOverview />} />
            <Route path="overview/update/:id" element={<UpdateOverview />} />
          </Route>
        </Route>

        <Route path="/error/401" element={<PageUnauthorize />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
